//////////////////////////////////////////////////////////////////////////
//                                                                      //
// This is a generated file. You can view the original                  //
// source in your browser if your browser supports source maps.         //
// Source maps are supported by all recent versions of Chrome, Safari,  //
// and Firefox, and by Internet Explorer 11.                            //
//                                                                      //
//////////////////////////////////////////////////////////////////////////


(function () {

/* Imports */
var Meteor = Package.meteor.Meteor;
var global = Package.meteor.global;
var meteorEnv = Package.meteor.meteorEnv;
var _ = Package.underscore._;
var meteorInstall = Package.modules.meteorInstall;
var Buffer = Package.modules.Buffer;
var process = Package.modules.process;
var Symbol = Package['ecmascript-runtime'].Symbol;
var Map = Package['ecmascript-runtime'].Map;
var Set = Package['ecmascript-runtime'].Set;
var meteorBabelHelpers = Package['babel-runtime'].meteorBabelHelpers;
var Promise = Package.promise.Promise;

/* Package-scope variables */
var WebApp;

var require = meteorInstall({"node_modules":{"meteor":{"webapp":{"webapp_client.js":function(){

////////////////////////////////////////////////////////////////////////
//                                                                    //
// packages/webapp/webapp_client.js                                   //
//                                                                    //
////////////////////////////////////////////////////////////////////////
                                                                      //
WebApp = {                                                            // 1
                                                                      //
  _isCssLoaded: function () {                                         // 3
    function _isCssLoaded() {                                         // 3
      if (document.styleSheets.length === 0) return true;             // 4
                                                                      //
      return _.find(document.styleSheets, function (sheet) {          // 7
        if (sheet.cssText && !sheet.cssRules) // IE8                  // 8
          return !sheet.cssText.match(/meteor-css-not-found-error/);  // 9
        return !_.find(sheet.cssRules, function (rule) {              // 10
          return rule.selectorText === '.meteor-css-not-found-error';
        });                                                           // 12
      });                                                             // 13
    }                                                                 // 14
                                                                      //
    return _isCssLoaded;                                              // 3
  }()                                                                 // 3
};                                                                    // 1
////////////////////////////////////////////////////////////////////////

}}}}},{"extensions":[".js",".json"]});
require("./node_modules/meteor/webapp/webapp_client.js");

/* Exports */
if (typeof Package === 'undefined') Package = {};
(function (pkg, symbols) {
  for (var s in symbols)
    (s in pkg) || (pkg[s] = symbols[s]);
})(Package.webapp = {}, {
  WebApp: WebApp
});

})();



/*****************
 ** WEBPACK FOOTER
 ** ./build/meteor/bundle/programs/web.browser/packages/webapp.js
 ** module id = ./build/meteor/bundle/programs/web.browser/packages/webapp.js
 ** module chunks = 0 1
 **/